import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch strike policies for a community.
 * Strike policies are threshold-based (triggered when accumulated points reach strikeThreshold),
 * not label-based like classification/moderation policies.
 */
export const GET_STRIKE_POLICIES = gql`
  query GetStrikePolicies($communityId: ID!) {
    community(id: $communityId) {
      id
      policies {
        id
        communityId
        name
        description
        isEnabled
        workflowType
        strikeThreshold
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
      }
    }
  }
`;
